const PlataformaLayout = resolve => {
    require.ensure(["./../layouts/PlataformaLayout.vue"], () => {
        resolve(require("./../layouts/PlataformaLayout.vue"));
    });
};
const RegistroLayout = resolve => {
    require.ensure(["./../layouts/RegistroLayout.vue"], () => {
      resolve(require("./../layouts/RegistroLayout.vue"));
    });
  };
const Plataforma = resolve => {
    require.ensure(["./../components/Inicio/Plataforma.vue"], () => {
      resolve(require("./../components/Inicio/Plataforma.vue"));
    });
};
const PagoTributoInicio = resolve => { 
    require.ensure(['./../components/Rentas/Inicio.vue'], ()=>{ 
        resolve(require('./../components/Rentas/Inicio.vue')); 
    }); 
};
const ContribuyentesTributos = resolve => { 
    require.ensure(['./../components/Rentas/ListaContribuyentes.vue'], ()=>{ 
        resolve(require('./../components/Rentas/ListaContribuyentes.vue')); 
    }); 
};
const EstadoCuentaTributos = resolve => { 
    require.ensure(['./../components/Rentas/EstadoCuenta.vue'], ()=>{ 
        resolve(require('./../components/Rentas/EstadoCuenta.vue')); 
    }); 
};
const EstadoCuentaSeleccionados = resolve => { 
    require.ensure(['./../components/Rentas/EstadoCuentaSeleccionado.vue'], ()=>{ 
        resolve(require('./../components/Rentas/EstadoCuentaSeleccionado.vue')); 
    }); 
};
const InicioPagoTributos = resolve => { 
    require.ensure(['./../components/Rentas/InicioPago.vue'], ()=>{ 
        resolve(require('./../components/Rentas/InicioPago.vue')); 
    });
};

const ResultadoPagoTributos = resolve => { 
    require.ensure(['./../components/Rentas/ResultadoPago.vue'], ()=>{ 
        resolve(require('./../components/Rentas/ResultadoPago.vue')); 
    });
};

const ContribuyenteCuponera = resolve => {
    require.ensure(['./../components/Rentas/ListaContribuyentesCuponera.vue'], () => {
        resolve(require('./../components/Rentas/ListaContribuyentesCuponera.vue'));
    });
};

const ConsultaCuponera = resolve => {
    require.ensure(['./../components/Rentas/ConsultaCuponera.vue'], () => {
        resolve(require('./../components/Rentas/ConsultaCuponera.vue'));
    });
};

const DescargaEstadoCuenta = resolve => { 
    require.ensure(['./../components/Rentas/EstadoCuentaDescarga.vue'], ()=>{ 
        resolve(require('./../components/Rentas/EstadoCuentaDescarga.vue')); 
    });
};

const DescargaCuponera = resolve => { 
    require.ensure(['./../components/Rentas/EstadoDescargaCuponera.vue'], ()=>{ 
        resolve(require('./../components/Rentas/EstadoDescargaCuponera.vue')); 
    });
};

export const routesRentas = [
    {
        path: "/",
        component: PlataformaLayout,
        children: [
            { 
                path : '/pago-tributo', 
                name: 'pagepagotributo', 
                component: PagoTributoInicio, 
                meta:{ 
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        }
                    ]
                }
            },
            { 
                path : '/pago-tributo/contribuyente', 
                name: 'pagecontribuyentes', 
                component: ContribuyentesTributos, 
                meta:{ 
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Contribuyentes', 
                            link:''
                        }
                    ]
                }
            },
            {
                path: '/pago-tributo/contribuyente/estado-cuenta',
                name: 'pageEstadoCuentaTributos',
                component: EstadoCuentaTributos,
                meta: {
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Contribuyentes', 
                            link:'/pago-tributo/contribuyente'
                        },
                        {
                            name:'Estado de cuenta', 
                            link:''
                        }
                    ]
                }
            },
            {
                path: '/pago-tributo/contribuyente/estado-cuenta/seleccionados',
                name: 'pageEstadoCuentaTributosSeleccionados',
                component: EstadoCuentaSeleccionados,
                meta: {
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Contribuyentes', 
                            link:'/pago-tributo/contribuyente'
                        },
                        {
                            name:'Estado de cuenta', 
                            link:'/pago-tributo/contribuyente/estado-cuenta'
                        },
                        {
                            name:'Recibos seleccionados', 
                            link:''
                        }
                    ]
                }
            },
            {
                path: '/pago-tributo/contribuyente/estado-cuenta/seleccionados/pago/:numeroPedido',
                name: 'pageTributosPago',
                component: InicioPagoTributos,
                meta: {
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Contribuyentes', 
                            link:'/pago-tributo/contribuyente'
                        },
                        {
                            name:'Estado de cuenta', 
                            link:'/pago-tributo/contribuyente/estado-cuenta'
                        },
                        {
                            name:'Pago',
                            link:''
                        }
                    ]
                }
            },
            {
                path: '/pago-tributo/contribuyente/estado-cuenta/seleccionados/resultadopago/:numeroPedido/:resultado/:mensaje',
                name: 'pageTributosRetornoPago',
                component: ResultadoPagoTributos,
                meta: {
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Contribuyentes', 
                            link:'/pago-tributo/contribuyente'
                        },
                        {
                            name:'Estado de cuenta', 
                            link:'/pago-tributo/contribuyente/estado-cuenta'
                        },
                        {
                            name:'Resultado del Pago',
                            link:''
                        }
                    ]
                }
            },
            {
                path: '/contribuyente-cuponera',
                name: 'contribuyenteCuponera',
                component: ContribuyenteCuponera,
                meta: {
                    breadCrumb: [{
                            name: 'Plataforma',
                            link: '/'
                        },
                        {
                            name: 'Consulta Cartilla Tributaria',
                            link: '/contribuyente-cuponera'
                        }
                    ]
                }
            },
            {
                path: '/consulta-cuponera',
                name: 'consultaCuponera',
                component: ConsultaCuponera,
                meta: {
                    breadCrumb: [{
                            name: 'Plataforma',
                            link: '/'
                        },
                        {
                            name: 'Consulta Cartilla Tributaria',
                            link: '/contribuyente-cuponera'
                        }
                    ]
                }
            },
        ]
    },
    {
        path: "/",
        component: RegistroLayout,
        children: [
          {
            path: '/descarga-eecc/:token',
            name: "descargaEstadoCuenta",
            component: DescargaEstadoCuenta,
            meta: {
              breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Descarga Estado Cuenta", link: "/descarga-eecc" }
              ]
            }
          },
          {
            path: '/descarga-cuponera/:token',
            name: "descargaCuponera",
            component: DescargaCuponera,
            meta: {
              breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Descarga Estado Cuenta", link: "/descarga-cuponera" }
              ]
            }
          },
          {
            path: '/descarga-cuponera/',
            name: "descargaCuponera",
            component: DescargaCuponera,
            meta: {
              breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Descarga Estado Cuenta", link: "/descarga-cuponera" }
              ]
            }
          },
          {
            path : '/pago-tributo/contribuyente/:parametro', 
            name: 'pagecontribuyentes', 
            component: ContribuyentesTributos, 
            meta:{ 
                breadCrumb: [
                    {
                        name: 'Plataforma', 
                        link:'/'
                    },
                    {
                        name:'Contribuyentes', 
                        link:''
                    }
                ]
            }
          },
        ]
      },
    
];


// WEBPACK FOOTER //
// ./src/router/routesRentas.js